import { render, staticRenderFns } from "./ImagePreviewBy.vue?vue&type=template&id=5850b29b&scoped=true&"
import script from "./ImagePreviewBy.vue?vue&type=script&lang=js&"
export * from "./ImagePreviewBy.vue?vue&type=script&lang=js&"
import style0 from "./ImagePreviewBy.vue?vue&type=style&index=0&id=5850b29b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5850b29b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5850b29b')) {
      api.createRecord('5850b29b', component.options)
    } else {
      api.reload('5850b29b', component.options)
    }
    module.hot.accept("./ImagePreviewBy.vue?vue&type=template&id=5850b29b&scoped=true&", function () {
      api.rerender('5850b29b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cargo/v0/ToolAssistant/ocr/components/ImagePreviewBy.vue"
export default component.exports